export default __webpack_public_path__ + "static/media/_IMG7734.9f85af5a.jpg";